module.exports = __webpack_public_path__ + "static/media/download.d5c9c87c.svg";